/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'rc-time-picker/assets/index.css';
import _ from 'lodash';
import People from '@material-ui/icons/People';
import DriveEta from '@material-ui/icons/DriveEta';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import List from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { mainColor, settings, SAVE_BUTTON_TEXT, UNIT } from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Spinner from '../Spinner';
import Button from '../Button';
import Switch from '../Switch';
import BackButton from '../BackButton';
import * as actions from '../../actions/index';
import {
  initData,
  onChangeLayout,
  addSteps,
  updateStepFees,
  handleRemoveFees,
  submit,
  handleToggle,
  updatePerKM,
  checkMinValue
} from './DeliverySettings.services';
import { styles } from './DeliverySettings.styles';
import IconButton from '../IconButton';
import {
  isShopUserServicePrice,
  isDeliveryPriceInKm,
  isFreelanceEnabled
} from '../../utils/delivery';

const ListItem = withStyles({
  root: {
    paddingLeft: '0px',
    paddingBottom: '5px',
    paddingTop: '0px',
    paddingRight: '0px'
  }
})(MuiListItem);
const INITIAL_STATE = {
  servicePrice: { perKm: {}, steps: {} },
  isLoading: false,
  isClient: false,
  checked: false
};

class DeliverySettings extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount = async () => {
    initData(this, !isFreelanceEnabled(this.props.shopId));
  }

  componentWillReceiveProps = async (nextProps) => {
    const { shopId, isAllShops, configuration, generalConfig } = nextProps;
    const { isClient } = this.state;
    const {
      shopId: oldShopId,
      isAllShops: oldIsAllShops,
      configuration: oldConfig,
      generalConfig: oldGeneralConfig
    } = this.props;
    const { delivery: shopDelivery = {} } = configuration;
    const { delivery: oldShopDelivery = {} } = oldConfig;
    const { delivery = {} } = generalConfig;
    const { delivery: oldDelivery = {} } = oldGeneralConfig;
    if (
      !_.isEqual(shopId, oldShopId) ||
      !_.isEqual(oldDelivery, delivery) ||
      !_.isEqual(oldShopDelivery, shopDelivery) ||
      (_.isEqual(shopId, oldShopId) && oldIsAllShops !== isAllShops)
    ) {
      initData(this, delivery.freelance || shopDelivery.freelance ? isClient : !isFreelanceEnabled(shopId));
    }
  }

  renderPerKm = () => {
    const { classes } = this.props;
    const { servicePrice = {} } = this.state;
    const { perKm } = servicePrice;
    return (
      <div className={`row m-0 p-3 `}>
        <div className='col-sm-5 mt-2'>
          <p className={classes.boldText}>Frais par km :</p>
          <p className={classes.headerFee}>
            Remplissez les champs pour définir les frais qui seront appliqués pour chaque km
            parcouru à partir d’un certain nombre de km.
          </p>
        </div>
        <div className='col-sm-7'>
          <div className='row justify-content-end'>
            <div className='row pr-5 pl-sm-2 '>
              <div className='col-sm-6 ml-3 m-sm-0 '>
                <Input
                  margin='dense'
                  id='from'
                  type='number'
                  label='À partir de '
                  fullWidth
                  value={perKm?.from < 0 ? 0 : perKm?.from}
                  onBlur={e => checkMinValue(e, this)}
                  onChange={event => updatePerKM(event, this)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>km</InputAdornment>
                  }}
                />
              </div>
              <div className='col-sm-6 ml-3 m-sm-0'>
                <Input
                  margin='dense'
                  id='fees'
                  type='number'
                  label='Frais de livraison'
                  fullWidth
                  value={perKm && (perKm.fees < 0 ? 0 : perKm.fees)}
                  onBlur={e => checkMinValue(e, this)}
                  onChange={event => updatePerKM(event, this)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderSteps = () => {
    const { classes } = this.props;
    const { servicePrice = {} } = this.state;
    const { steps = [] } = servicePrice;
    return (
      <div className={`row m-0 p-3 ${classes.root}`}>
        <div className='col-sm-5 mt-2'>
          <p className={classes.boldText}>
            Frais par palier :{' '}
            <IconButton
              label='Add'
              title='Ajouter un pallier'
              className={classes.iconStyle}
              onClick={() => addSteps(this)}
            >
              <AddIcon style={{ fontSize: UNIT }} />
            </IconButton>
          </p>
          <p className={classes.headerFee}>
            Créez vos différents paliers de kilométrage et définissez les frais qui seront appliqués
            à chaque palier.
          </p>
        </div>
        <div className='col-sm-7'>
          <div className='row justify-content-end'>
            {_.map(
              steps,
              (step, index) =>
                step && (
                  <>
                    <div className='row pr-3 pl-sm-2 '>
                      <div className='col-sm-6 ml-3 m-sm-0 '>
                        <Input
                          margin='dense'
                          id='km'
                          type='number'
                          label='À partir de '
                          name={index}
                          fullWidth
                          value={step.km < 0 ? 0 : step.km}
                          onBlur={e => checkMinValue(e, this, step)}
                          onChange={event => updateStepFees(event, this, step)}
                          InputLabelProps={{
                            shrink: true
                          }}
                          InputProps={{
                            endAdornment: <InputAdornment position='end'>km</InputAdornment>
                          }}
                        />
                      </div>
                      <div className='col-sm-6 ml-3 m-sm-0'>
                        <Input
                          margin='dense'
                          id='fees'
                          type='number'
                          label='Frais de livraison'
                          fullWidth
                          value={step.fees < 0 ? 0 : step.fees}
                          onBlur={e => checkMinValue(e, this, step)}
                          onChange={event => updateStepFees(event, this, step)}
                          InputLabelProps={{
                            shrink: true
                          }}
                          InputProps={{
                            endAdornment: <InputAdornment position='end'>€</InputAdornment>
                          }}
                        />
                      </div>
                    </div>
                    <IconButton
                      size='small'
                      label='Remove'
                      title='Supprimer le palier'
                      onClick={() => handleRemoveFees(index, this)}
                      style={{
                        alignSelf: 'flex-end',
                        backgroundColor: 'transparent'
                      }}
                    >
                      <DeleteOutlinedIcon className={classes.removeIcon} />
                    </IconButton>
                  </>
                )
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { classes, history = {}, sidebarCollapse, isAllShops, shopId } = this.props;
    const { isLoading, isClient = !isFreelanceEnabled(shopId), checked } = this.state;
    return (
      <div className={`col-12 p-4 ${sidebarCollapse && 'col-lg-10'} px-0`}>
        <div className='row mx-0 align-items-center'>
          <BackButton
            className='col-12 col-md-9 pl-0'
            onClick={() => history.goBack()}
            title={settings.DeliverySettings.text}
            subtitle={settings.DeliverySettings.description}
          />

          <div className='col-12 col-md-3 col-xl-3 d-flex justify-content-end align-items-end px-0'>
            {isFreelanceEnabled(shopId) && (
              <IconButton
                aria-label='livreur'
                title='Frais livreur par Km'
                className={`mx-2 ${!isClient ? classes.driverIcon : classes.arroundIcon} my-0 mr-0`}
                style={{
                  border: !isClient && '2px solid',
                  backgroundColor: !isClient && 'transparent',
                  borderColor: !isClient && mainColor.secondaryColor
                }}
                onClick={() => {
                  onChangeLayout(false, this);
                }}
              >
                <DriveEta style={{ color: !isClient && mainColor.secondaryColor }} />
              </IconButton>
            )}
            <IconButton
              aria-label='client'
              title='Frais client par Km'
              className={`mx-2 ${isClient ? classes.driverIcon : classes.arroundIcon} my-0`}
              style={{
                border: isClient && '2px solid',
                backgroundColor: isClient && 'transparent',
                borderColor: isClient && mainColor.secondaryColor
              }}
              onClick={() => {
                onChangeLayout(true, this);
              }}
            >
              <People style={{ color: isClient && mainColor.secondaryColor }} />
            </IconButton>
          </div>
        </div>

        <Paper className={`col-12 px-0 my-3 ${classes.paperStyle}`}>
          {isClient && (
            <List>
              <ListItem style={{ width: `${UNIT * 5}%` }}>
                <ListItemText className='row m-0 p-3'>
                  {' '}
                  <p className={`col-sm-12 mt-2  ${classes.boldText}`}>
                    {checked
                      ? isAllShops
                        ? 'Désactiver les paramètres des frais de livraison par kilomètre.'
                        : 'Désactiver les paramètres des frais de livraison par kilomètre pour votre établissement.'
                      : isAllShops
                        ? 'Activer les paramètres des frais de livraison par kilomètre.'
                        : 'Activer les paramètres des frais de livraison par kilomètre pour votre établissement.'}{' '}
                  </p>
                  {isClient &&
                    !isShopUserServicePrice() &&
                    !checked &&
                    !isAllShops &&
                    isDeliveryPriceInKm() && (
                      <p className={`col-sm-12 mt-2 ${classes.headerFee}`}>
                        Ci dessous les frais de livraison côté client configurés par
                        l'administrateur et appliqués à votre établissement.
                      </p>
                    )}
                  {isClient && checked && isAllShops && (
                    <p className={`col-sm-12 mt-2 ${classes.headerFee}`}>
                      Ci dessous, les paramètres appliqués au réseau.
                    </p>
                  )}
                </ListItemText>
                <ListItemSecondaryAction style={{ right: UNIT * 3.0625 }}>
                  <Switch
                    className={`col-sm-12 mt-2  ${classes.boldText}`}
                    checked={checked}
                    color='primary'
                    onChange={e => handleToggle(e, this)}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          )}
          {((!isClient) ||
            (isClient && (isDeliveryPriceInKm() || (!isDeliveryPriceInKm() && checked)))) && (
              <div
                className={
                  isClient &&
                  !isShopUserServicePrice() &&
                  !checked &&
                  !isAllShops &&
                  classes.disabledStyle
                }
              >
                <div> {this.renderPerKm()}</div>
                <div> {this.renderSteps()}</div>

                <div className='d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4'>
                  <div className={`px-sm-${isLoading ? 5 : 0} `}>
                    {isLoading ? (
                      <Spinner size={30} />
                    ) : (
                      <Button color='primary' onClick={e => submit(e, this)} className='btn-primary'>
                        <div className='row justify-content-center align-items-center mr-0 ml-0'>
                          <p className='mx-0'>{SAVE_BUTTON_TEXT}</p>
                        </div>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
        </Paper>
      </div>
    );
  }
}

function mapStateToProps({ user, firebaseRealTime, sidebar }) {
  const { shopId, isAllShops } = user;
  const { shop = {}, generalConfig } = firebaseRealTime;
  const { configuration = {} } = shop;
  const { sidebarCollapse } = sidebar;
  return {
    shopId,
    isAllShops,
    configuration,
    sidebarCollapse,
    generalConfig,
    shop
  };
}
DeliverySettings.propTypes = {
  classes: PropTypes.element.isRequired
};
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(DeliverySettings)));
